import { render, staticRenderFns } from "./mountain-bike-insurance.vue?vue&type=template&id=6ca72ee7&scoped=true"
import script from "./mountain-bike-insurance.vue?vue&type=script&lang=js"
export * from "./mountain-bike-insurance.vue?vue&type=script&lang=js"
import style0 from "./mountain-bike-insurance.vue?vue&type=style&index=0&id=6ca72ee7&prod&lang=scss&scoped=true"
import style1 from "./mountain-bike-insurance.vue?vue&type=style&index=1&id=6ca72ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca72ee7",
  null
  
)

export default component.exports